/**
 * @name BackupDialog
 * @description Modal para añadir un backup
 * @author Gerardo de León
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import moment from 'moment';
import styled from 'styled-components';

import { Environment } from '@config';
import { EmployeeDetail, AppDetail } from '@components';
import { EmployeeService, BackupService, NotificationsService, ResponseHandlerService } from '@services';
import { Icons, Layout, MUI, Typography } from '@styles';

class BackupDialog extends Component {
  constructor(props) {
    super(props);
    this.userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
    this.state = {
      employeesListIndicators: [],
      employeesListHelpDesk: [],

      responsabilitiesIndicadotorsList: [],
      responsabilitiesHelpDeskList: [],
      responsabilitiesCheckedList: [false, false, false, false, false],
      responsabilitiesIdsListIndicators: [],
      responsabilitiesIdsListHelpDesk: [],
      counterChecked: 0,
      backup: '',
      backupHelpDesk: '',
      backupIndicators: '',
      backupIdRequest: 0,
      backupDetailIndicators: {
        id: 0,
        name: '',
        photo: '',
        job: '',
      },
      backupDetailHelpDesk: {
        id: 0,
        name: '',
        photo: '',
        job: '',
      },
      startDate: moment(new Date()).add(1, 'days').startOf('day'),
      endDate: moment(new Date()).add(1, 'days').startOf('day'),
      comment: '',
      indicatorResponsibilities: false,
      helpDeskResponsabilities: false
    };

    this.schema = Yup.object({
      startDate: Yup.object().nullable().required('*'),
      endDate: Yup.object().nullable().required('*'),
      comment: Yup.string()
        .min(2, i18n.t('FormsGeneralTexts.min2Chars'))
        .max(250, i18n.t('FormsGeneralTexts.max250Chars'))
        .required('*')
    });
  }

  componentDidMount() {
    this.getEmployeesIndicators();
    this.getEmployeesHelpDesk();
    this.getResponsabilities(this.userInfo.IdEmpleado);

  }

  /**
   * Consulta todos los empleados en estatus 'Alta'
   */
  getEmployeesIndicators = () => {
    EmployeeService.get({ page: 0, size: 0, filter: { estatus: true, idAplicacion: 3, esBackup: true } })
      .then((response) => {
        let employeesListIndicators = response.filter((employee) => employee.IdEmpleado !== this.userInfo.IdEmpleado);
        this.setState({ employeesListIndicators });
      })
      .catch(() => { });
  }

  getEmployeesHelpDesk = () => {
    EmployeeService.get({ page: 0, size: 0, filter: { estatus: true, idAplicacion: 21, esBackup: true } })
      .then((response) => {
        let employeesListHelpDesk = response.filter((employee) => employee.IdEmpleado !== this.userInfo.IdEmpleado);
        this.setState({ employeesListHelpDesk });
      })
      .catch(() => { });
  }

  // Consulta todas las responsabilidades
  getResponsabilities = (idEmployee) => {
    BackupService.getResponsabilieties(idEmployee)
      .then((response) => {
        let responsabilitiesIndicadotorsList = response.filter((resp) => resp.IdResponsabilidad !== 5);
        let responsabilitiesHelpDeskList = response.filter((resp) => resp.IdResponsabilidad === 5);

        this.setState({ responsabilitiesIndicadotorsList, responsabilitiesHelpDeskList });
      })
      .catch(() => { });
  }

  /**
   * Seleciona un empleado de backup
   * @param {object} employee
   */
  setBackup = (employee, type) => {
    let employeeSelect = {
      id: employee ? employee.IdEmpleado : 0,
      name: employee ? employee.Nombre : '',
      photo: employee ? employee.Foto : '',
      job: employee ? employee.Puesto : '',
    };
    switch (type) {
      case 1:
        this.setState({ backupIndicators: employee, backupDetailIndicators: employeeSelect });
        break;

      case 2:
        this.setState({ backupHelpDesk: employee, backupDetailHelpDesk: employeeSelect });
        break;
    }
  }

  onAdd = (values, resetForm, setSubmitting) => {
    const { backupDetailIndicators, backupDetailHelpDesk } = this.state;

    // Obtiene los id que se enviarán por medio de los arreglos
    this.state.responsabilitiesCheckedList.forEach((resp, index) => {
      if (resp && index < 4) {
        this.state.responsabilitiesIdsListIndicators.push(this.state.responsabilitiesIndicadotorsList[index].IdResponsabilidad);
      }
      else if (resp && index == 4) {
        this.state.responsabilitiesIdsListHelpDesk.push(this.state.responsabilitiesHelpDeskList[0].IdResponsabilidad);
      }
    });

    let request = {
      IdEmpleado: this.userInfo.IdEmpleado,
      Mediciones: this.state.indicatorResponsibilities ? {
        IdEmpleadoBackup: backupDetailIndicators.id,
        IdAplicacion: 3,
        IdResponsabilidades: this.state.responsabilitiesIdsListIndicators
      } : null,
      HelpDesk: this.state.helpDeskResponsabilities ? {
        IdEmpleadoBackup: backupDetailHelpDesk.id,
        IdAplicacion: 21,
        IdResponsabilidades: this.state.responsabilitiesIdsListHelpDesk
      } : null,
      FechaInicio: new Date(values.startDate),
      FechaFin: new Date(values.endDate),
      Comentario: values.comment,
    };

    request.FechaInicio.setUTCHours(0, 0, 0, 0);
    request.FechaFin.setUTCHours(23, 59, 59, 999);

    // Notificación - <colaborador> te ha asignado como su backup del <fechaInicio> al <fechaFin>
    /*let notificationToSend = {
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      IdTipoNotificacion: 129,
      IdEmpleado: backupDetail.id,
      Parametros: JSON.stringify({ Tab: 6 }),
      Propiedades: JSON.stringify({
        colaborador: backupDetail.name,
        fechaInicio: values.startDate.format('DD/MM/YYYY'),
        fechaFin: values.endDate.format('DD/MM/YYYY')
      })
    };*/

    BackupService.post(request)
      .then((response) => {
        setSubmitting(false);
        resetForm();
        this.props.onClose();
        this.props.getBackup('');
        this.setState({ responsabilitiesIdsList: [] });
        ResponseHandlerService.success(response);
      })
      .catch((error) => {
        setSubmitting(false);
        this.setState({ responsabilitiesIdsList: [] });
        ResponseHandlerService.error(error);
      });
  }

  handleChange = (event) => {
    let responsabilitiesCheckedList = this.state.responsabilitiesCheckedList;
    let counterChecked = this.state.counterChecked;

    switch (event.target.name) {
      case 'indicatorResponsibilities':
        if (event.target.checked) {
          this.setState({ indicatorResponsibilities: event.target.checked });
        }
        else {
          responsabilitiesCheckedList = [false, false, false, false, false,];
          responsabilitiesCheckedList[4] = this.state.responsabilitiesCheckedList[4];
          counterChecked = this.state.responsabilitiesCheckedList[4] ? 1 : 0;
          let backupIndicators = '';
          this.setState({
            indicatorResponsibilities: event.target.checked,
            responsabilitiesCheckedList,
            counterChecked,
            backupIndicators
          });
        }
        break;
      case 'helpDeskResponsabilities':
        if (event.target.checked) {
          this.setState({ helpDeskResponsabilities: event.target.checked });
        }
        else {
          responsabilitiesCheckedList[0] = this.state.responsabilitiesCheckedList[0];
          responsabilitiesCheckedList[1] = this.state.responsabilitiesCheckedList[1];
          responsabilitiesCheckedList[2] = this.state.responsabilitiesCheckedList[2];
          responsabilitiesCheckedList[3] = this.state.responsabilitiesCheckedList[3];
          responsabilitiesCheckedList[4] = false;
          let backupHelpDesk = '';
          counterChecked = 0;
          this.state.responsabilitiesCheckedList.forEach((resp) => {
            if (resp) {
              counterChecked = counterChecked + 1;
            }
          });
          this.setState({
            helpDeskResponsabilities: event.target.checked,
            responsabilitiesCheckedList,
            counterChecked,
            backupHelpDesk
          });

        }
        break;
      case 'indicador1':
        responsabilitiesCheckedList[0] = event.target.checked;
        this.setState({
          responsabilitiesCheckedList,
          counterChecked: event.target.checked ? counterChecked + 1 : counterChecked - 1
        });
        break;
      case 'indicador2':
        responsabilitiesCheckedList[1] = event.target.checked;
        this.setState({
          responsabilitiesCheckedList,
          counterChecked: event.target.checked ? counterChecked + 1 : counterChecked - 1
        });
        break;
      case 'indicador3':
        responsabilitiesCheckedList[2] = event.target.checked;
        this.setState({
          responsabilitiesCheckedList,
          counterChecked: event.target.checked ? counterChecked + 1 : counterChecked - 1
        });
        break;
      case 'indicador4':
        responsabilitiesCheckedList[3] = event.target.checked;
        this.setState({
          responsabilitiesCheckedList,
          counterChecked: event.target.checked ? counterChecked + 1 : counterChecked - 1
        });
        break;
      case 'helpDesk1':
        responsabilitiesCheckedList[4] = event.target.checked;
        this.setState({
          responsabilitiesCheckedList,
          counterChecked: event.target.checked ? counterChecked + 1 : counterChecked - 1
        });
        break;
      default:
        break;
    }
  };


  render() {
    const {
      employeesListHelpDesk,
      employeesListIndicators,
      backupHelpDesk,
      backupIndicators,
      backupDetailIndicators,
      backupDetailHelpDesk,
      startDate,
      endDate,
      comment,
      indicatorResponsibilities,
      helpDeskResponsabilities,
      responsabilitiesIndicadotorsList,
      responsabilitiesHelpDeskList,
      responsabilitiesCheckedList,
      counterChecked
    } = this.state;

    const { open, onClose, } = this.props;

    return (
      <MUI.Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        disableBackdropClick
      >
        <MUI.DialogTitle>
          {`${i18n.t('GenericMessages.add')} ${i18n.t('Backup').toLowerCase()}`}
          <MUI.DialogBoxClose onClick={onClose}>
            <Icons.Close />
          </MUI.DialogBoxClose>
        </MUI.DialogTitle>

        <Formik
          enableReinitialize
          initialValues={{ startDate, endDate, comment }}
          validationSchema={this.schema}
          isInitialValid={this.schema.isValidSync({ startDate, endDate, comment })}
          onSubmit={(values, { resetForm, setSubmitting }) => {
            this.onAdd(values, resetForm, setSubmitting);
          }}
        >
          {(formikProps) => {
            return (
              <>
                <MUI.DialogContent>

                  <MUI.Box padding="8px">
                    <Typography.H6>{i18n.t('BackupSettings.respToDelegate')}</Typography.H6>
                  </MUI.Box>

                  { /** GRID de módulos */}
                  <MUI.Grid container >

                    { /* Responsabilidades de Mediciones  */}
                    {responsabilitiesIndicadotorsList.length > 0 && (
                      <>
                        <MUI.Grid item md={1} sm={1} xs={12}>
                          <MUI.Box>
                            <AppDetail
                              app={'https://assets.talentry.io/icons/appicons/metrics.png'}
                              appSize={'sm'}
                            />
                          </MUI.Box>
                        </MUI.Grid>
                        <MUI.Grid item md={5} sm={5} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('BackupSettings.respIndicatorsBackup')}
                              control={<MUI.Switch
                                checked={indicatorResponsibilities}
                                onChange={this.handleChange}
                                name="indicatorResponsibilities" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                      </>
                    )}

                    { /* Responsabilidades de Mesa de ayuda  */}
                    {responsabilitiesHelpDeskList.length > 0 && (
                      <>
                        <MUI.Grid item md={1} sm={1} xs={12}>
                          <MUI.Box>
                            <AppDetail
                              app={'https://assets.talentry.io/icons/appicons/helpcenter.png'}
                              appSize={'sm'}
                            />
                          </MUI.Box>
                        </MUI.Grid>
                        <MUI.Grid item md={5} sm={5} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('BackupSettings.respHelpDeskBackup')}
                              control={<MUI.Switch
                                checked={helpDeskResponsabilities}
                                onChange={this.handleChange}
                                name="helpDeskResponsabilities" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                      </>
                    )}
                  </MUI.Grid>

                  { /** GRID de módulos */}
                  <MUI.Grid container >

                    <MUI.Grid item md={1} sm={1} xs={12}>
                    </MUI.Grid>

                    {/* Colaborador */}
                    <MUI.Grid item md={5} sm={5} xs={12}>
                      {indicatorResponsibilities && (
                        <>
                          <MUI.Box padding="8px">
                            <MUI.Autocomplete
                              label={i18n.t('GenericMessages.employee')}
                              searchList={employeesListIndicators}
                              searchBy="Nombre"
                              value={backupIndicators}
                              onChange={(newValue) => this.setBackup(newValue, 1)}
                              name={'IndicatorsBackup'}
                            />
                          </MUI.Box>
                        </>
                      )}
                    </MUI.Grid>


                    <MUI.Grid item md={1} sm={1} xs={12}>
                    </MUI.Grid>

                    {/* Colaborador */}
                    <MUI.Grid item md={5} sm={5} xs={12}>
                      {helpDeskResponsabilities && (
                        <>
                          <MUI.Box padding="8px">
                            <MUI.Autocomplete
                              label={i18n.t('GenericMessages.employee')}
                              searchList={employeesListHelpDesk}
                              searchBy="Nombre"
                              value={backupHelpDesk}
                              onChange={(newValue) => this.setBackup(newValue, 2)}
                              name={'helpDeskBackup'}
                            />
                          </MUI.Box>
                        </>
                      )}
                    </MUI.Grid>
                  </MUI.Grid>

                  { /** GRID de responsabilidades */}
                  <MUI.Grid container style={{ marginBottom: '20px' }}>

                    { /** Lista de responsabilidades del módulo de Indicadores */}
                    <MUI.Grid item md={1} sm={1} xs={12} ></MUI.Grid>
                    <MUI.Grid item md={5} sm={5} xs={12} >
                      {indicatorResponsibilities && (
                        <>
                          {responsabilitiesIndicadotorsList.map((resp, index) => {
                            return (
                              <MUI.CheckboxLabel
                                key={index}
                                label={resp.Responsabilidad}
                                name={'indicador' + (index + 1)}
                                control={
                                  <MUI.Checkbox
                                    checked={responsabilitiesCheckedList[index]}
                                    onChange={this.handleChange}
                                  />
                                }
                              />
                            );
                          })}

                        </>
                      )}
                    </MUI.Grid>

                    { /** Lista de responsabilidades del módulo de Mesa de ayuda */}
                    <MUI.Grid item md={1} sm={1} xs={12} ></MUI.Grid>
                    <MUI.Grid item md={5} sm={5} xs={12} >
                      {helpDeskResponsabilities && (
                        <>
                          {responsabilitiesHelpDeskList.map((resp, index) => {
                            return (
                              <MUI.CheckboxLabel
                                key={index}
                                label={resp.Responsabilidad}
                                name={'helpDesk' + (index + 1)}
                                control={
                                  <MUI.Checkbox
                                    checked={responsabilitiesCheckedList[4]}
                                    onChange={this.handleChange}
                                  />
                                }
                              />
                            );
                          })}
                        </>
                      )}
                    </MUI.Grid>

                  </MUI.Grid>

                  {/* Periodo Backup */}
                  <MUI.Box padding="8px">
                    <Typography.H6>{i18n.t('BackupSettings.periodApply')}</Typography.H6>
                  </MUI.Box>
                  <MUI.Grid container alignItems="center">
                    {/* Fecha Inicio */}
                    <MUI.Grid item md={6} sm={6} xs={12}>
                      <MUI.Box padding="8px">
                        <MUI.DatePicker
                          allowKeyboard={true}
                          label={i18n.t('GenericMessages.startDate')}
                          orientation={'landscape'}
                          format={i18n.t('FormatDates.short')}
                          invalidDateMessage={i18n.t('FormatDates.invalidDate')}
                          minDate={moment().add(1, 'days')}
                          minDateMessage={i18n.t('FormatDates.invalidMinDate')}
                          value={formikProps.values.startDate}
                          onChange={(newDate) => formikProps.setFieldValue('startDate', newDate)}
                          openTo="date"
                        />
                      </MUI.Box>
                    </MUI.Grid>
                    {/* Fecha Fin */}
                    <MUI.Grid item md={6} sm={6} xs={12}>
                      <MUI.Box padding="8px">
                        <MUI.DatePicker
                          allowKeyboard={true}
                          label={i18n.t('GenericMessages.endDate')}
                          value={formikProps.values.endDate}
                          orientation={'landscape'}
                          format={i18n.t('FormatDates.short')}
                          invalidDateMessage={i18n.t('FormatDates.invalidDate')}
                          minDate={moment(formikProps.values.startDate)}
                          minDateMessage={i18n.t('FormatDates.invalidMinDate')}
                          onChange={(newDate) => formikProps.setFieldValue('endDate', newDate)}
                          openTo="date"
                        />
                      </MUI.Box>
                    </MUI.Grid>
                  </MUI.Grid>
                  {/* Comentario */}
                  <MUI.Grid item md={12} sm={12}>
                    <MUI.Box padding="8px">
                      <MUI.TextField
                        multiline
                        label={i18n.t('GenericMessages.comment')}
                        type="text"
                        name="comment"
                        value={formikProps.values.comment}
                        characterLimit={250}
                        onBlur={formikProps.handleBlur}
                        onChange={formikProps.handleChange}
                        error={Boolean(formikProps.touched.comment && formikProps.errors.comment)}
                        helperText={formikProps.touched.comment && formikProps.errors.comment}
                        inputProps={{ maxLength: '250' }}
                      />
                    </MUI.Box>
                  </MUI.Grid>
                </MUI.DialogContent >

                <MUI.DialogActions>
                  <Layout.BoxRequired>
                    {`* ${i18n.t('FormsGeneralTexts.required')}`}
                  </Layout.BoxRequired>
                  <MUI.ButtonText onClick={onClose}>
                    {i18n.t('DialogConfirm.cancel')}
                  </MUI.ButtonText>

                  <MUI.ButtonCTA type="button" color="primary" disabled={!formikProps.isValid || formikProps.isSubmitting || (indicatorResponsibilities && !backupIndicators) || (helpDeskResponsabilities && !backupHelpDesk) || counterChecked < 1 || formikProps.values.startDate > formikProps.values.endDate} onClick={formikProps.handleSubmit}>
                    {i18n.t('DialogConfirm.save')}
                  </MUI.ButtonCTA>
                </MUI.DialogActions>
              </>
            );
          }}
        </Formik>
      </MUI.Dialog >
    );
  }
}

BackupDialog.propTypes = {
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta cuando se cierra el modal.
  onClose: PropTypes.func.isRequired,
  // Función que se ejecuta para actualizar los backup.
  getBackup: PropTypes.func.isRequired,
};

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.BoxSwitch = styled.div`
  width: 100%;
  padding: 8px;
`;

export default BackupDialog;
